import AuditDetailView from "./AuditDetailView";

const AuditDetailModal = ({
    audit,
    onClose
}) => {

    if (!audit) {
        return null;
    }

    return (

        <div
            className="va-modal-overlay"
            onClick={onClose}
        >

            <div
                className="va-modal"
                onClick={(e) =>
                    e.stopPropagation()
                }
            >

                {/* Header */}
                <div className="va-modal-header">

                    <h3>

                        Audit Details

                        {
                            audit.question_code &&
                            ` - ${audit.question_code}`
                        }

                    </h3>

                    <button
                        type="button"
                        className="va-modal-close"
                        onClick={onClose}
                    >
                        ✕
                    </button>

                </div>

                {/* Metadata */}
                <div className="va-audit-meta">

                    <span>
                        <strong>Action:</strong>{" "}
                        {audit.action || "-"}
                    </span>

                    <span>
                        <strong>Module:</strong>{" "}
                        {audit.module_name || "-"}
                    </span>

                    <span>
                        <strong>Performed By:</strong>{" "}
                        {audit.performed_by_name || "-"}
                    </span>

                    <span>
                        <strong>Date:</strong>{" "}
                        {audit.performed_at || "-"}
                    </span>

                </div>

                {/* Details */}
                <div className="va-modal-body">

                    <AuditDetailView
                        audit={audit}
                    />

                </div>

            </div>

        </div>
    );
};

export default AuditDetailModal;